import { List } from 'immutable';
import TeamMemberModel from 'models/TeamMemberModel';

import { fundingSearchFollowers, updateSearchFollower } from './types';

export * from './actions';

const searchManagerReducerObject = {
  [fundingSearchFollowers.request]: (state, action) =>
    state.setIn(['fundingSearchFollowers', action.fundingSearchId, 'network', 'loading'], true),
  [fundingSearchFollowers.success]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['fundingSearchFollowers', action.fundingSearchId, 'network', 'loading'], false)
        .setIn(['fundingSearchFollowers', action.fundingSearchId, 'network', 'error'], false)
        .setIn(
          ['fundingSearchFollowers', action.fundingSearchId, 'data'],
          List(action.response.map((member) => TeamMemberModel.deserialize(member))),
        ),
    ),
  [fundingSearchFollowers.failure]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(
          ['fundingSearchFollowers', action.fundingSearchId, 'available', 'network', 'loading'],
          false,
        )
        .setIn(
          ['fundingSearchFollowers', action.fundingSearchId, 'available', 'network', 'error'],
          action.error,
        ),
    ),

  [updateSearchFollower.request]: (state, action) =>
    state.setIn(
      ['fundingSearchFollowers', action.fundingSearchId, 'update', 'network', 'loading'],
      true,
    ),
  [updateSearchFollower.success]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(
          ['fundingSearchFollowers', action.fundingSearchId, 'update', 'network', 'loading'],
          false,
        )
        .setIn(
          ['fundingSearchFollowers', action.fundingSearchId, 'update', 'network', 'error'],
          false,
        )
        .setIn(
          ['fundingSearchFollowers', action.fundingSearchId, 'data'],
          List(action.response.map((member) => TeamMemberModel.deserialize(member))),
        ),
    ),
  [updateSearchFollower.failure]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(
          ['fundingSearchFollowers', action.fundingSearchId, 'update', 'network', 'loading'],
          false,
        )
        .setIn(
          ['fundingSearchFollowers', action.fundingSearchId, 'update', 'network', 'error'],
          action.error,
        ),
    ),
};

export default searchManagerReducerObject;
